var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.71429C0 0.767512 0.767512 0 1.71429 0H28.2857C29.2325 0 30 0.767512 30 1.71429V28.2857C30 29.2325 29.2325 30 28.2857 30H1.71429C0.767512 30 0 29.2325 0 28.2857V1.71429Z",
    fill: "#292828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.2322C16.1391 13.2322 17.0625 12.3088 17.0625 11.1697C17.0625 10.0306 16.1391 9.10718 15 9.10718C13.8609 9.10718 12.9375 10.0306 12.9375 11.1697C12.9375 12.3088 13.8609 13.2322 15 13.2322Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 20.009C9.10718 17.4053 11.4817 15.2947 14.4107 15.2947",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1786 16.5322C16.1786 16.2179 18.2411 15.5894 18.2411 15.5894C18.2411 15.5894 20.3036 16.2179 20.3036 16.5322C20.3036 19.0465 18.2411 20.3036 18.2411 20.3036C18.2411 20.3036 16.1786 19.0465 16.1786 16.5322Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.be88c4456f3d9bd3f7acbcd05ef30942.svg";
export { ForwardRef as ReactComponent };